
import React, { useEffect } from 'react';
import '../../App.css';
import '../Styles/vision.css';
import image from '../Assets/vision-image.png'

function Vision() {
  useEffect(() => {
    function visible(el) {
      var rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
    function handleAnimations() {
      var contentElement = document.querySelector('.vision .content');
      var imageElement = document.querySelector('.vision .vision_image');
    
      if (visible(contentElement)) {
        contentElement.style.opacity = 1;
        contentElement.style.transition = 'opacity 1s ease';
      }
    
      if (visible(imageElement)) {
          imageElement.style.transform = 'scale(1.5)';
          imageElement.style.transition = 'transform 1s ease';
      }
    }
    window.addEventListener('scroll', handleAnimations);
  }, []);

  return (
    <div className="vision" id='vision'>
        
            <div className="vision_heading">
              <div className="heading">Our Vision</div>
            </div>
            <div className="vision_body">
              <img alt= "vision logo" src={image} className="vision_image" width="100%" height="100%" />
            <div className="content">
              Our vision is to grow our multi-disciplinary team in order to offer a broad spectrum of specialist Pipeline Consulting services to become our Clients' preferred Professional Service Provider (PSP) choice through excellence and efficiency in all aspects of the project life cycle. We work hard to cater to our client`s needs with the best metal solutions around the world, & revolutionizing the supply chains of the industries we serve. We leave a long-lasting impression in our client`s minds by supplying optimum quality products that will exceed expectations and set new standards!
  
          </div>
      </div>
    </div>
  );
}

export default Vision;